import * as React from 'react'
import { Fragment } from 'react'
import { CalendarHeadRows, CalendarHelper } from './calendar'
import { Element, RentList } from './warehouse_rent_list_types'
import ElementRentListRow from './element_rent_list_row'

interface RentListData extends RentList {
  quantity?: number
}

interface OverviewCalendarTableProps {
  startDate: string
  endDate: string
  groupedAvailableElements: Record<string, Element[]>
  elementGroups: Record<string, string>
  rentedItems: Record<string, any>
  rentList: RentList | null
}

function OverviewCalendarTable({
  startDate,
  endDate,
  groupedAvailableElements,
  elementGroups,
  rentedItems,
  rentList,
}: OverviewCalendarTableProps): React.ReactElement {
  const cal = new CalendarHelper(startDate, endDate)

  // Get all unique rent lists for element
  const getRentListsForElement = (element: Element): RentListData[] => {
    const items = rentedItems[element.id] || []

    const rentListsMap = new Map<number, RentListData>()

    items.forEach((item: any) => {
      if (item.rentList) {
        rentListsMap.set(item.rentList.id, {
          ...item.rentList,
          quantity: (rentListsMap.get(item.rentList.id)?.quantity || 0) + (item.quantity || 1),
        })
      }
    })

    const result = Array.from(rentListsMap.values())
    return result
  }

  return (
    <table className="rent-list-table table table-bordered table-hover">
      <thead>
        <CalendarHeadRows startDate={startDate} endDate={endDate} />
      </thead>
      <tbody>
        {Object.keys(groupedAvailableElements).map((groupId) => (
          <Fragment key={`group-${groupId}`}>
            <tr className="rent-list-table-group-row">
              <td className="rent-list-table-element-cell" colSpan={cal.totalDays() + 1}>
                <span className="rent-list-table-element-cell-content">
                  <b>{elementGroups[groupId]}</b>
                </span>
              </td>
            </tr>
            {groupedAvailableElements[groupId].map((element) => {
              const elementRentLists = getRentListsForElement(element)

              if (elementRentLists.length === 0) {
                // Element not rented - show one row
                return (
                  <ElementRentListRow 
                    key={`element-${element.id}`} 
                    element={element} 
                    rentListData={null}
                    startDate={startDate}
                    endDate={endDate}
                    getRentListsForElement={getRentListsForElement}
                  />
                )
              } else {
                // Element rented - show row for each rent list
                return elementRentLists.map((rentListData) => (
                  <ElementRentListRow
                    key={`element-${element.id}-rentlist-${rentListData.id}`}
                    element={element}
                    rentListData={rentListData}
                    startDate={startDate}
                    endDate={endDate}
                    getRentListsForElement={getRentListsForElement}
                  />
                ))
              }
            })}
          </Fragment>
        ))}
      </tbody>
    </table>
  )
}

OverviewCalendarTable.defaultProps = {
  rentList: null,
}

export default OverviewCalendarTable
